import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {runGuestPickerBedroomsExperiment} from '../../../utils/experiments';

import {useOptions} from './useOptions';

const defaultGuestsOptions = {
    actionLocation: undef,
    adultsMax: undef,
    adultsMin: undef,
    allowErrorHighlighting: undef,
    autoSubmit: undef,
    bedroomsMax: undef,
    bedroomsMin: undef,
    centered: undef,
    childrenMax: undef,
    childrenMin: undef,
    disableTextInput: undef,
    fadeOut: false,
    fadeOutDuration: 0,
    id: 'guests',
    inputIconName: 'group',
    name: 'guests',
    placement: 'bottom',
    positionIconRight: undef,
    showBedroomsOption: undef,
    showClearButton: false,
    showContinue: undef,
    showInputIcon: undef,
    showPetOption: true,
    wdioPrefix: undef
};

function useGuestsOptions(props, abacusStore) {
    const {
        guestsOptions: propsGuestsOptions
    } = props;

    const experimentGuestsOptions = {
        showBedroomsOption: runGuestPickerBedroomsExperiment({shouldLogExperiment: false}, abacusStore) || undef
    };

    const {
        options: guestsOptions
    } = useOptions(defaultGuestsOptions, experimentGuestsOptions, propsGuestsOptions);

    const result = {
        guestsOptions
    };

    useDebugValue(result);

    return result;
}

export {useGuestsOptions};
